import { render, staticRenderFns } from "./ConfirmDeposit.vue?vue&type=template&id=760cd84d"
import script from "./ConfirmDeposit.vue?vue&type=script&lang=js"
export * from "./ConfirmDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports